export default __webpack_public_path__ + "static/media/AppCrash.f25d6fb8.png";